import { get } from "lodash-es"
import dayjs from "dayjs"
import { useDispatch, useSelector } from "react-redux"
import { ApplicationState, Modules } from ".."
import {
  changeDate,
  SEARCH_FILTER_CHANGE_DATE,
  SEARCH_FILTER_CHANGE_PAGE,
  changePage,
  changeSearch,
  SEARCH_FILTER_CHANGE_SEARCH,
  changeFilter,
  SEARCH_FILTER_CHANGE_FILTER,
} from "../search-filter/search-filter.actions"
import Dayjs from "utils/dayjs.utils"
import { ORDER_STATUSES } from "../../data/orderStatuses"
const INITIAL_STATE = {
  vehicles: {
    date: Dayjs.date,
    page: 0,
    search: "",
    filter: {},
  },
  benchmarks: {
    page: 0,
    filter: {},
  },
  ecommerce: {
    filter: {},
  },
  vendors: {
    filter: {},
  },
  dispatch: {
    filter: {
      dateRange: [Dayjs.date, Dayjs.date],
      orderStatus: ORDER_STATUSES.filter(o => o.id === "RFS"),
    },
  },
  "fund-flow": {
    filter: {
      dateRange: [Dayjs.date, Dayjs.date],
    },
  },
  supplier: {
    filter: {
      status: [null, "RDY"],
      isArchived: false,
    },
  },
  interfaces: {
    filter: {},
  },
  "sellable-items": {
    filter: {},
  },
  "distribution-centers": {
    filter: {},
  },
  docks: {
    filter: {},
  },
}

export function searchFilterReducer(state = INITIAL_STATE, action: any) {
  switch (action?.type) {
    case SEARCH_FILTER_CHANGE_DATE:
      return {
        ...state,
        [action.path]: {
          ...get(state, action.path),
          date: dayjs(action.payload).format("YYYY-MM-DD"),
          page: 0,
        },
      }
    case SEARCH_FILTER_CHANGE_PAGE:
      return {
        ...state,
        [action.path]: {
          ...get(state, action.path),
          page: action.payload,
        },
      }

    case SEARCH_FILTER_CHANGE_SEARCH:
      return {
        ...state,
        [action.path]: {
          ...get(state, action.path),
          search: action.payload,
          page: 0,
        },
      }
    case SEARCH_FILTER_CHANGE_FILTER:
      return {
        ...state,
        [action.path]: {
          ...get(state, action.path),
          filter: action.payload,
        },
      }

    default:
      return state
  }
}

export function useDate(path: Modules): [string | Date, (date: any) => void] {
  const date = useSelector<ApplicationState, Date | string>(
    state => state.searchFilter?.[path]?.date
  )
  const dispatch = useDispatch()
  function handleChange(date: any) {
    dispatch(changeDate(date, path))
  }
  return [date, handleChange]
}

export function usePagination(
  path: Modules
): [number, (page: string | number) => void] {
  const page = useSelector<ApplicationState, number>(
    state => state.searchFilter?.[path]?.page
  )
  const dispatch = useDispatch()

  function handleChange(page: string | number) {
    dispatch(changePage(page, path))
  }
  return [page, handleChange]
}

/**
 *
 * @deprecated Do Not use this hook, please use useSearchQuery instead
 */
export function useSearchQuery_DEPRECATED(
  path: Modules
): [string, (query: string) => void] {
  const search = useSelector<ApplicationState, string>(
    state => state.searchFilter?.[path]?.search
  )
  const dispatch = useDispatch()

  function handleChange(search: string) {
    dispatch(changeSearch(search, path))
  }
  return [search, handleChange]
}

export function useFilter<T = any>(
  path: Modules
): [T, (filter: T | any) => void] {
  const filter = useSelector<ApplicationState, T>(
    state => state.searchFilter?.[path]?.filter
  )

  const dispatch = useDispatch()

  function handleChange(filter: T | any) {
    dispatch(changeFilter(filter, path))
  }
  return [filter, handleChange]
}
